import styled from "styled-components";
import {Button} from "antd";

export const PageHeader = styled.div`
    width: 100%;
    max-width: 1400px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 16px;

    h2 {
        margin: 0;
    }
`;

export const FiltersRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;

    > * {
        width: 240px;
        max-width: 100%;
    }

    @media (max-width: 576px) {
        > * {
            width: 100%;
        }
    }
`;

export const CreateTicketButton = styled(Button)`
    display: flex;
    align-items: center;
    gap: 8px;
    height: 40px;
    border-radius: 8px;
    font-weight: 500;
    background-color: #aef001;
    border-color: #aef001;
    color: #000;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);

    &:hover:not(:disabled),
    &:focus:not(:disabled) {
        background-color: #9dd600;
        border-color: #9dd600;
        color: #000;
        transform: translateY(-2px);
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
    }

    &:active:not(:disabled) {
        transform: translateY(0);
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
    }

    &:disabled {
        background-color: #f5f5f5;
        border-color: #d9d9d9;
        color: rgba(0, 0, 0, 0.25);
        box-shadow: none;
    }

    @media screen and (max-width: 768px) {
        height: 36px;
        font-size: 14px;
        gap: 6px;
    }
`;
